import apiCities from "../../../api/cityes/apiCities";
import { useDispatch, useSelector } from "react-redux";
import { setBoundsMap, setBusStaitionsOnMap, setBusStations, setBusStationsShippingFrom, setBusStationsShippingTo, setBusStationsTo, setCitiesTo, setCity, setViewPortMapMode } from "../store/mapScreenSlce";
import { useEffect, useState } from "react";
import { OptionType } from "../components/InputForms/SelectInputMap/SelectInputMap";
import { ICity } from "@/shared/types/city";
import { IResponseGetCities } from "@/api/cityes/type";
import { IBusStation } from "@/shared/types/busStaition";
import { IParameter } from "@/api/types";
import { RootState } from "@/store/redux/store";
import useMap from "./useMap";
import useCity from "./useCity";
import { getStopsFrom, getStopsTo } from "../../../services/GET_FROM_OR_TO/GET_FROM_OR_TO";
import { mapFormStationsToBusStations } from "./utils";
import { adapterBusStaitions } from "../utils/adapterBusStaitions";

function useFormBusStaitions() {
    const dispatch = useDispatch();
    const { selectCity } = useCity();
    const { changeStateAndZoomMap, selectBusStaition, getMapBoundsForBusstaintions } = useMap();
    const { busStations, date, loadings } = useSelector((state: RootState) => state.mapScreen);
    const [cities, setCities] = useState<ICity[]>([]);
    const [isLoadingCities, setIsLoading] = useState<boolean>(false);
    const [isLoadingBusStaitions, setIsLoadingBusStations] = useState<boolean>(loadings.includes('busStaitions'));
    const [citiesInputOptions, setCitiesInputOptions] = useState<OptionType[]>();
    const [busStationsInputOptions, setBusStationsInputOptions] = useState<OptionType[]>();

    useEffect(() => { setIsLoadingBusStations(loadings.includes('busStaitions')); }, [loadings])

    function fillCities(response: IResponseGetCities) {
        const cities = adapterCities(response.cities);
        setCities(cities);
        return cities;
    }

    function fillStaition(
        staitionsFrom: any,
        staitionsTo: any,
        isMap: boolean = true,
        isBouncedMap = true,
        //boundsOptions?: TBound,
    ) {

        let staitions = []

        if (staitionsFrom) {
            const forBusStaitionStateFrom = mapFormStationsToBusStations(staitionsFrom);
            staitions = staitions.concat(forBusStaitionStateFrom);
            dispatch(setBusStations(forBusStaitionStateFrom))
            dispatch(setBusStationsShippingFrom(staitionsFrom))
        }

        if (staitionsTo) {
            const forBusStaitionStateTo = mapFormStationsToBusStations(staitionsTo);
            staitions = staitions.concat(forBusStaitionStateTo);
            dispatch(setBusStationsTo(forBusStaitionStateTo))
            dispatch(setBusStationsShippingTo(staitionsTo))
        }

        if (isMap) {
            //@ts-ignore
            const busStations = adapterBusStaitions(staitions);
            dispatch(setBusStaitionsOnMap(busStations));
            if (isBouncedMap) {
                const bounds = getMapBoundsForBusstaintions(busStations);
                dispatch(setViewPortMapMode('bounds'));
                dispatch(setBoundsMap({ values: bounds.bounds, options: bounds.options }))
            }
        }
    }

    function fillCitiesOptions(cities: ICity[]) {
        const options = adapterOptions(cities);
        setCitiesInputOptions(options);
    }

    async function getCities(value: string | undefined) {
        try {
            setIsLoading(true);
            const response = await apiCities.getCities(
                { NFIRST_ROWNUM: 0, NLAST_ROWNUM: 20000, CFILTER: value ?? '', NID: null }
            );
            const cities = fillCities(response)
            fillCitiesOptions(cities);
            setIsLoading(false);
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    }

    function selectCityForm(param: OptionType) {
        const selectedCity = cities.find((c) => c.id.toString() === param.value.toString());
        if (selectedCity) {
            selectCity(selectedCity);
        }
    }

    function fillBusStationsInputOptions() {
        const options = adapterOptions(busStations);
        setBusStationsInputOptions(options);
    }

    function selectBusStaitionFromInput(option: IParameter) {
        const finded = busStations.find(s => s.id === option.value);
        if (finded) {
            selectBusStaition(finded);
        }
    }

    useEffect(() => { fillBusStationsInputOptions() }, [busStations]);

    /** наполнить оп между двумя нас пунктами */
    async function fillStaitionsBehindTwoCities(cityId: string, cityToId: string) {
        try {
            const [staitionsFromRes, staitionsToRes] = await Promise.all([
                getStopsFrom({ localityIdFrom: cityId, localityIdTo: cityToId }, true),
                getStopsTo({ localityIdFrom: cityId, localityIdTo: cityToId }, true),
            ])
            fillStaition(staitionsFromRes, staitionsToRes)
        }
        catch (err) {
            console.error(err)
        }
    }

    /** наполнить все оп из которых можно уехать и приехать в области */
    async function fillAllStaitionsFromAndTo() {
        try {
            const [staitionsFromRes, staitionsToRes] = await Promise.all([
                getStopsFrom({}, true),
                getStopsTo({}, true),
            ])
            fillStaition(staitionsFromRes, staitionsToRes)
        }
        catch (err) {
            console.error(err)
        }
    }

    /** остановки на которые можно приехать с отсановки */
    async function fillStaitionsShippingByStaitionFrom(staitionId: string, cityIdFrom?: number, isBouncedMap?: boolean) {
        try {
            const staitionsToRes = await getStopsTo({ stopPointIdFrom: staitionId.toString() }, true);
            const staitionsFrom = cityIdFrom ? await getStopsFrom({ localityIdFrom: cityIdFrom.toString() }, true) : undefined;
            fillStaition(staitionsFrom, staitionsToRes, true, isBouncedMap)
        }
        catch (err) {
            console.error(err)
        }
    }

    /** остановки из которых можно уехать на отсановку */
    async function fillStaitionsShippingFROMTO(staitionId: string, isBouncedMap?: boolean) {
        try {
            const staitionsToRes = await getStopsFrom({ stopPointIdFrom: staitionId.toString() }, true);
            fillStaition(undefined, staitionsToRes, isBouncedMap)
        }
        catch (err) {
            console.error(err)
        }
    }

    /** Получить ОП прибытия из ОП отправления и нас пункт прибытия*/
    async function fillStaitionsShippingByArriveStaitionAndCityTo(staitionId: string, cityToId: string, cityId: string) {
        try {
            const staitionsToRes = await getStopsTo({
                stopPointIdFrom: staitionId.toString(),
                localityIdTo: cityToId,
                localityIdFrom: cityId
            }, true);
            fillStaition(undefined, staitionsToRes)
        }
        catch (err) {
            console.error(err)
        }
    }

    /** Оставки из ГОРОДА */
    async function fillBusStationsFromFromCity(city: ICity) {
        try {
            const staitions = await getStopsFrom({ localityIdFrom: city.id.toString() }, true);
            fillStaition(staitions, undefined)
        }
        catch (err) {

        }
    }

    /** Остановки в которые можно приехать из города */
    async function fillBusStationsToFromCity(city: ICity, isFill: boolean = true) {
        try {
            const staitions = await getStopsTo({ localityIdFrom: city.id.toString() }, true);
            fillStaition(undefined, staitions, isFill);
        }
        catch (err) {

        }
    }
    return ({
        getCities,
        selectCityForm,
        isLoadingCities,
        isLoadingBusStaitions,
        citiesInputOptions,
        busStationsInputOptions,
        selectBusStaitionFromInput,

        fillStaitionsShippingByStaitionFrom,
        fillStaitionsShippingFROMTO,

        fillStaitionsBehindTwoCities,
        fillAllStaitionsFromAndTo,
        fillStaitionsShippingByArriveStaitionAndCityTo,

        fillBusStationsFromFromCity,
        fillBusStationsToFromCity,
    })
}

export default useFormBusStaitions;

function adapterOptions(array: ICity[] | IBusStation[]): OptionType[] {
    return array.map((el) => ({
        label: el.name,
        value: el.id ? el.id.toString() : el.area_id ? el.area_id.toString() : '',
    }));
}

function adapterCities(cities: Record<string, ICity>): ICity[] {
    const citieKeys = Object.keys(cities);
    const updated = citieKeys.reduce((array: ICity[], key: string) => {
        array.push(cities[key]);
        return array;
    }, []);

    return updated;
}